import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNotificationSnackbar } from '../../services/controllers/common/CommonSelector';
import { hideNotification } from '../../services/controllers/common/CommonSlice';

const MessageSnackbar: React.FC = () => {
  const dispatch = useDispatch();

  const { message, type, open } = useSelector(selectNotificationSnackbar);

  const onClose = () => {
    dispatch(hideNotification());
  };
  return (
    <Snackbar open={open} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={3000}>
      <Alert severity={type} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackbar;
